export enum TransactionStatus {
  'Completed' = 'Completed',
  'Pending' = 'Pending',
  'Failed' = 'Failed',
}

export enum TransactionStatusColor {
  'Pending' = 'tertiary',
  'Completed' = 'success',
  'Failed' = 'danger',
}
